exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog[data-v-99ee29e4]{min-width:320px;padding:4px}.buttons[data-v-99ee29e4]{margin-top:16px;text-align:right}.form[data-v-99ee29e4]{margin-bottom:20px}", ""]);

// exports
